module.exports = __webpack_public_path__ + "static/media/lei_seg.2c371bd4.m4a";